import { Link } from "react-router-dom";
import { ArrowUpRight, Check, Building2 } from "lucide-react";
import { Reveal, SectionHead } from "../components/ui-bits";
import { IMAGES } from "../config/images";

const VALUE = ["Reliable recurring service", "Standardized quality", "Water-efficient process", "Centralized service management"];

export default function ForBusiness() {
  return (
    <section id="business" className="relative overflow-hidden py-20 lg:py-28" data-testid="b2b-teaser-section">
      <div className="absolute inset-0 opacity-25" style={{ backgroundImage: `url(${IMAGES.b2bIndia})`, backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, #130826 0%, rgba(19,8,38,0.88) 30%, rgba(19,8,38,0.92) 70%, #130826 100%)" }} />
      <div className="container-x relative grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <SectionHead
            eyebrow="For Business"
            title={<>Built for Businesses That Move.</>}
            sub="Standardized, convenient and water-efficient vehicle care for dealerships, EV manufacturers, fleets, companies, societies and mobility businesses."
          />
          <Reveal delay={0.15} className="mt-8">
            <div className="flex flex-wrap gap-2">
              {["Dealerships", "EV manufacturers", "Used-car showrooms", "Corporate fleets", "Rental & mobility", "Residential societies", "Corporate campuses"].map((t) => (
                <span key={t} className="flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.03] px-3.5 py-1.5 text-xs text-mist" data-testid="b2b-teaser-chip">
                  <Building2 size={11} className="text-carza-lite" /> {t}
                </span>
              ))}
            </div>
          </Reveal>
          <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {VALUE.map((v, i) => (
              <Reveal key={v} delay={0.1 + i * 0.05}>
                <div className="flex items-center gap-3 rounded-xl border border-white/5 bg-white/[0.02] px-4 py-3.5" data-testid={`b2b-teaser-value-${i}`}>
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-carza-dim text-carza-lite"><Check size={12} /></span>
                  <span className="text-sm font-medium text-paper">{v}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal delay={0.1} className="lg:col-span-5 lg:pl-6">
          <div className="glass rounded-3xl p-8 text-center" data-testid="b2b-teaser-card">
            <p className="font-display text-2xl font-bold text-paper">Get a program built for your vehicles.</p>
            <p className="mt-3 text-sm leading-relaxed text-mist">Segments, services, business impact and a tailored proposal — all in one place.</p>
            <Link to="/for-business" className="btn btn-primary mt-7 w-full py-4" data-testid="b2b-teaser-cta">
              Explore For Business <ArrowUpRight size={15} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
